import { useMemo, useState } from 'react'
import { lightImpactVibrate } from '../utils/appBridge'

export const useScaleAnimation = () => {
  const [scale, setScale] = useState(1)

  const triggerAnimation = () => {
    setScale(0.95)
    setTimeout(() => setScale(1), 100)
    lightImpactVibrate()
  }

  const scaleStyle = useMemo(() => {
    return {
      transform: `scale(${scale})`,
      transition: 'transform 0.1s ease'
    }
  }, [scale])

  return {
    scaleStyle,
    triggerAnimation
  }
}
